import { NavLink } from 'react-router-dom'
import PropTypes from 'prop-types'
import { Typography, Alert, Button, IconButton } from '@mui/material'

import { ReactComponent as X } from '../../../assets/icons/x.svg'

import useStyles from './styles'

const PrintAlertView = ({ description, textButton, urlButton, closeAlert }) => {
  const classes = useStyles()

  const handleCloseClick = ev => {
    closeAlert()
  }
  return (
    <Alert severity="warning" className={classes.root}>
      <IconButton
        size="medium"
        onClick={handleCloseClick}
        className={classes.closeButton}
      >
        <X />
      </IconButton>

      <Typography component="p" variant="body2">
        {description}
      </Typography>

      <Button
        component={NavLink}
        size="small"
        to={urlButton}
        onClick={handleCloseClick}
        className={classes.downloadButton}
      >
        <Typography component="span" variant="h4">
          {textButton}
        </Typography>
      </Button>
    </Alert>
  )
}

PrintAlertView.propTypes = {
  description: PropTypes.string,
  textButton: PropTypes.string,
  urlButton: PropTypes.string,
  closeAlert: PropTypes.func.isRequired,
}

export default PrintAlertView
